import React from 'react';
import { thisAcademicYear } from '../utils/utils.statiquedata';
import { useFees } from '../utils/fees';
import { APPNAME } from '../utils/utils.constants';
import { BreadcrumpComponent } from '../components/subcomponents/BreadcrumpCompont';
import { PageSectionHeader } from '../components/subcomponents/PageSectionHeader';
import { Paymenentinfos } from '../components/subcomponents/Paymenentinfos';
import { FeesGrid } from '../components/subcomponents/FeesGrid';
import { Colors } from '../utils/utils.colors';
import { FaCircleInfo } from 'react-icons/fa6';
import bigCover from '../assets/images/big-cover.jpg';
import { Link } from 'react-router-dom';
import { routes } from '../utils/utils.routes';

const InfoIcon = FaCircleInfo as any;

export const FraisAcademiques: React.FC = () => {
  const { fees, loading } = useFees();

  return (
    <>
      <BreadcrumpComponent
        title="Frais académiques"
        subtitle={`Consultez la grille officielle des frais académiques de l'${APPNAME} pour l'année ${thisAcademicYear}.`}
        imageCover={bigCover}
      />

      <div className="padding-x site-content" style={{ paddingTop: '3rem', paddingBottom: '4rem' }}>
        <main className="wp-block-group alignfull has-global-padding is-layout-constrained wp-block-group-is-layout-constrained">
          <PageSectionHeader
            eyebrow="Frais"
            title={`Frais académiques et frais connexes | ${thisAcademicYear}`}
            lead="Retrouvez ci-dessous le détail complet des frais académiques par promotion et par faculté."
            align="center"
          />

          <div style={{ marginTop: '2rem' }}>
            {loading ? (
              <p style={{ textAlign: 'center', color: '#666' }}>Chargement de la grille des frais…</p>
            ) : (
              <FeesGrid data={fees} />
            )}
          </div>
          <div style={{ height: 16 }} aria-hidden="true" className="wp-block-spacer"></div>
          <span style={{ marginTop: 12 }} className='mt-2'>
            <InfoIcon style={{ color: Colors.primaryColor, marginRight: 8, verticalAlign: 'middle' }} />
            Tous les frais sont à verser sur les comptes officiels de {APPNAME} soit payés dans les guichets au niveau du service de finance situé dans le campus Moïse dans le bâtiment de l'administration centrale.
          </span>
          <Paymenentinfos />
          <p style={{ marginTop: 24 }}>
            <Link to={routes.GUIDE_INSCRIPTION} style={{ color: Colors.primaryColor, fontWeight: 600 }}>
              Consulter le guide d&apos;inscription complet →
            </Link>
          </p>
        </main>
      </div>
    </>
  );
};
